/* ============================================================
   HijabFam Social Scroller — hijabfam-scroller.js
   Upload to: Shopify Admin → Online Store → Themes → Assets
   ============================================================ */

(function () {
  'use strict';

  document.querySelectorAll('[id^="hf-scroller-"]').forEach(function (section) {

    var trackId   = section.id + '-track';
    var track     = document.getElementById(trackId);
    if (!track) return;

    var speed      = parseInt(section.dataset.speed, 10) || 40;
    var pauseHover = section.dataset.pause !== 'false';
    var prevBtn    = section.querySelector('.hf-scroller__arrow--prev');
    var nextBtn    = section.querySelector('.hf-scroller__arrow--next');
    var container  = section.querySelector('.hf-scroller__track-container');

    /* ─────────────────────────────────────────────
       1. Clone cards for seamless infinite loop
    ───────────────────────────────────────────── */
    var origCards = Array.from(track.children);
    if (!origCards.length) return;

    // Clone 3 full sets so there's always content on both sides
    for (var c = 0; c < 3; c++) {
      origCards.forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
    }

    /* ─────────────────────────────────────────────
       2. State
    ───────────────────────────────────────────── */
    var cardW      = origCards[0].offsetWidth + 16; // card width + gap
    var setW       = origCards.length * cardW;       // one full set width
    var currentX   = 0;                              // our manual offset
    var autoX      = 0;                              // auto-scroll position
    var isManual   = false;                          // true when user takes over
    var raf        = null;
    var lastTime   = null;
    var paused     = false;

    /* ─────────────────────────────────────────────
       3. Apply transform
    ───────────────────────────────────────────── */
    function wrapX(x) {
      x = x % setW;
      if (x > 0)    x -= setW;
      if (x < -setW) x += setW;
      return x;
    }

    function setTransform(x) {
      currentX = wrapX(x);
      track.style.transform = 'translateX(' + currentX + 'px)';
    }

    /* ─────────────────────────────────────────────
       4. Auto-scroll RAF loop
    ───────────────────────────────────────────── */
    var pxPerSec = setW / speed;

    function autoLoop(ts) {
      if (!lastTime) lastTime = ts;
      var dt = (ts - lastTime) / 1000;
      lastTime = ts;

      if (!paused && !isManual) {
        autoX -= pxPerSec * dt;
        autoX  = wrapX(autoX);
        track.style.transform = 'translateX(' + autoX + 'px)';
        currentX = autoX;
      }

      raf = requestAnimationFrame(autoLoop);
    }

    raf = requestAnimationFrame(autoLoop);

    /* ─────────────────────────────────────────────
       5. Pause on hover
    ───────────────────────────────────────────── */
    if (pauseHover) {
      section.addEventListener('mouseenter', function () { paused = true; });
      section.addEventListener('mouseleave', function () { paused = false; });
    }

    /* ─────────────────────────────────────────────
       6. Smooth slide to target
    ───────────────────────────────────────────── */
    var STEP = cardW * 1;
    var animating = false;

    function slideTo(targetX) {
      if (animating) return;
      animating = true;
      isManual  = true;

      targetX = wrapX(targetX);

      var startX = currentX;
      var diff   = targetX - startX;

      // take shortest path
      if (diff > setW / 2)   diff -= setW;
      if (diff < -setW / 2)  diff += setW;

      var duration = 500;
      var startTs  = null;

      function ease(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
      }

      function step(ts) {
        if (!startTs) startTs = ts;
        var progress = Math.min((ts - startTs) / duration, 1);
        var x = startX + diff * ease(progress);
        track.style.transform = 'translateX(' + x + 'px)';
        currentX = x;

        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          currentX  = wrapX(currentX);
          autoX     = currentX;
          lastTime  = null;
          animating = false;
          isManual  = false;
        }
      }

      requestAnimationFrame(step);
    }

    /* ─────────────────────────────────────────────
       7. Arrow buttons
    ───────────────────────────────────────────── */
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        slideTo(currentX + STEP);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        slideTo(currentX - STEP);
      });
    }

    /* ─────────────────────────────────────────────
       8. Drag / Swipe
    ───────────────────────────────────────────── */
    var dragStartX   = null;
    var dragStartPos = null;
    var dragging     = false;

    function pointerStart(clientX) {
      dragStartX   = clientX;
      dragStartPos = currentX;
      dragging     = false;
      isManual     = true;
      paused       = true;
    }

    function pointerMove(clientX) {
      if (dragStartX === null) return;
      var delta = clientX - dragStartX;
      if (Math.abs(delta) > 5) dragging = true;
      if (dragging) {
        var newX = dragStartPos + delta;
        newX = wrapX(newX);
        currentX = newX;
        track.style.transform = 'translateX(' + newX + 'px)';
      }
    }

    function pointerEnd(clientX) {
      if (dragStartX === null) return;
      var delta = clientX - dragStartX;

      if (dragging && Math.abs(delta) > 50) {
        var target = currentX + (delta > 0 ? STEP : -STEP);
        isManual = false;
        slideTo(target);
        setTimeout(function () { paused = false; }, 520);
      } else {
        autoX    = currentX;
        lastTime = null;
        isManual = false;
        paused   = false;
      }

      dragStartX   = null;
      dragStartPos = null;
    }

    if (container) {
      container.addEventListener('mousedown', function (e) {
        pointerStart(e.clientX);
      });
      window.addEventListener('mousemove', function (e) {
        if (dragStartX !== null) pointerMove(e.clientX);
      });
      window.addEventListener('mouseup', function (e) {
        if (dragStartX !== null) pointerEnd(e.clientX);
      });

      container.addEventListener('touchstart', function (e) {
        pointerStart(e.touches[0].clientX);
      }, { passive: true });

      container.addEventListener('touchmove', function (e) {
        pointerMove(e.touches[0].clientX);
        if (dragging) e.preventDefault();
      }, { passive: false });

      container.addEventListener('touchend', function (e) {
        pointerEnd(e.changedTouches[0].clientX);
      });

      // Block click-through after drag
      container.addEventListener('click', function (e) {
        if (dragging) {
          e.preventDefault();
          e.stopPropagation();
          dragging = false;
        }
      }, true);
    }

    /* ─────────────────────────────────────────────
       9. Recalculate on resize
    ───────────────────────────────────────────── */
    window.addEventListener('resize', function () {
      cardW    = origCards[0].offsetWidth + 16;
      setW     = origCards.length * cardW;
      pxPerSec = setW / speed;
      autoX    = 0;
      currentX = 0;
      lastTime = null;
      track.style.transform = 'translateX(0px)';
    });

  });

})();